import API from "../../api";
import { Sun, Moon, Monitor, Check } from "lucide-react";
import { useEffect, useState } from "react";
import "./settings.css";
export default function AppearanceSettings() {
  const [selectedTheme, setSelectedTheme] = useState(
    () => localStorage.getItem("civilink_theme") || "system"
  );

  const applyTheme = (theme) => {
    let finalTheme = theme;

    if (theme === "system") {
      finalTheme = window.matchMedia(
        "(prefers-color-scheme: dark)"
      ).matches
        ? "dark"
        : "light";
    }

    document.documentElement.setAttribute(
      "data-theme",
      finalTheme
    );

    localStorage.setItem("civilink_theme", theme);
  };

  const setTheme = async (theme) => {
    setSelectedTheme(theme);

    // Apply immediately
    applyTheme(theme);

    // Save to backend
    try {
      await API.put("/users/theme", {
        theme,
      });
    } catch {
      // Silent fail
    }
  };

  useEffect(() => {
    const savedTheme =
      localStorage.getItem("civilink_theme") || "system";

    setSelectedTheme(savedTheme);
    applyTheme(savedTheme);
  }, []);

  const themes = [
    {
      id: "light",
      label: "Light",
      description: "Bright and clean",
      icon: Sun,
    },
    {
      id: "dark",
      label: "Dark",
      description: "Easier on the eyes",
      icon: Moon,
    },
    {
      id: "system",
      label: "System",
      description: "Follow device settings",
      icon: Monitor,
    },
  ];

  return (
    <section className="settings-card appearance-settings">
      <div className="card-header">
        <h3>Appearance</h3>
        <p>Choose how Civilink looks</p>
      </div>

      <div className="appearance-options">
        {themes.map((theme) => {
          const Icon = theme.icon;
          const active = selectedTheme === theme.id;

          return (
            <button
              key={theme.id}
              type="button"
              className={`appearance-option ${
                active ? "active" : ""
              }`}
              onClick={() => setTheme(theme.id)}
            >
              <div className="appearance-icon">
                <Icon size={20} />
              </div>

              <div className="appearance-content">
                <strong>{theme.label}</strong>
                <span>{theme.description}</span>
              </div>

              <div
                className={`appearance-check ${
                  active ? "visible" : ""
                }`}
              >
                <Check size={15} />
              </div>
            </button>
          );
        })}
      </div>
    </section>
  );
}